/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiNewScreeningAlertFilter,
    ApiNewScreeningAlertFilterFromJSON,
    ApiNewScreeningAlertFilterToJSON,
    ApiScreeningAlertFilter,
    ApiScreeningAlertFilterFromJSON,
    ApiScreeningAlertFilterToJSON,
} from '../models';

export interface AddFilterRequest {
    apiNewScreeningAlertFilter: ApiNewScreeningAlertFilter;
}

export interface DeleteFilterRequest {
    id: number;
}

export interface UpdateFilterRequest {
    id: number;
    apiNewScreeningAlertFilter: ApiNewScreeningAlertFilter;
}

/**
 * 
 */
export class ScreeningAlertFilterApi extends runtime.BaseAPI {

    /**
     */
    async addFilterRaw(requestParameters: AddFilterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiScreeningAlertFilter>> {
        if (requestParameters.apiNewScreeningAlertFilter === null || requestParameters.apiNewScreeningAlertFilter === undefined) {
            throw new runtime.RequiredError('apiNewScreeningAlertFilter','Required parameter requestParameters.apiNewScreeningAlertFilter was null or undefined when calling addFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening-alerts/filters`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiNewScreeningAlertFilterToJSON(requestParameters.apiNewScreeningAlertFilter),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiScreeningAlertFilterFromJSON(jsonValue));
    }

    /**
     */
    async addFilter(requestParameters: AddFilterRequest, initOverrides?: RequestInit): Promise<ApiScreeningAlertFilter> {
        const response = await this.addFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteFilterRaw(requestParameters: DeleteFilterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening-alerts/filters/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteFilter(requestParameters: DeleteFilterRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteFilterRaw(requestParameters, initOverrides);
    }

    /**
     */
    async findFiltersRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiScreeningAlertFilter>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening-alerts/filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiScreeningAlertFilterFromJSON));
    }

    /**
     */
    async findFilters(initOverrides?: RequestInit): Promise<Array<ApiScreeningAlertFilter>> {
        const response = await this.findFiltersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateFilterRaw(requestParameters: UpdateFilterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiScreeningAlertFilter>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateFilter.');
        }

        if (requestParameters.apiNewScreeningAlertFilter === null || requestParameters.apiNewScreeningAlertFilter === undefined) {
            throw new runtime.RequiredError('apiNewScreeningAlertFilter','Required parameter requestParameters.apiNewScreeningAlertFilter was null or undefined when calling updateFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening-alerts/filters/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiNewScreeningAlertFilterToJSON(requestParameters.apiNewScreeningAlertFilter),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiScreeningAlertFilterFromJSON(jsonValue));
    }

    /**
     */
    async updateFilter(requestParameters: UpdateFilterRequest, initOverrides?: RequestInit): Promise<ApiScreeningAlertFilter> {
        const response = await this.updateFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
